export default {
  methods: {
    showTitle(item) {
      return (item.meta && item.meta.title) || item.name;
    },

    showChildren(item) {
      return (
        item.children &&
        (item.children.length > 1 || (item.meta && item.meta.showAlways))
      );
    },

    getNameOrHref(item, children_zero) {
      return item.href
        ? `isTurnByHref_${item.href}`
        : children_zero
        ? item.children[0].name
        : item.name;
    },
  },
};
